import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import moment from "moment";
import { Button } from "reactstrap";
import Switch from "react-switch";
import Collapsible from "react-collapsible"
import ProfileUpdateRender from "../profileUpdateRender"
import ImageModal from "../../imageModal";
import { getSignedUrlApiAction } from "../../../../services/Store/Actions/appActions";
import { deleteServiceHistory, getServiceHistory, getVehicleProfileData } from "../../../../services/Store/Actions/fleetActions";
import { BallTriangle } from "react-loader-spinner";
import DataTable from "react-data-table-component";

function ServiceHistory(props) {
  const dispatch = useDispatch();

    const { type,value ,expenseType, fleetId, vehicle} = props
    console.log("keyvaluedata ServiceHistory",type, value ,expenseType, vehicle);
  const [loading, setLoading] = useState(false);

    const [imageUrl, setImageUrl] = useState('');
    useEffect(() => {
      setLoading(true);
      dispatch(getServiceHistory({fleetId,expenseType}, (res)=> {
        console.log("useEffectServiceHistory",res?.data?.data);
      }))
      setLoading(false);
    }, [fleetId,expenseType])
    const serviceHistoryCount  = useSelector(
      (state) => state?.fleet?.serviceHistoryCount
    );
    const serviceHistory  = useSelector(
      (state) => state?.fleet?.serviceHistory
    );
    const [imageModal, setImageModal] = useState(false);
    const closeImageModal = () => {
        setImageModal(false);
    };
    const toggleImageModal = () => {
        setImageModal(!imageModal);
    }
   
 
  const printDocument = (image) => () => {
    console.log("printDocumentprintDocument",image);
    if(!imageUrl){
      dispatch(
        getSignedUrlApiAction(
          { key: image },
          (res) => {
            // setDownloadLoader2(false);
            // setLoaderInvoiceId("");
            if (res.status == 200) {
              setImageUrl(res?.data?.data)
             
            }
          }
        )
      );
    }
    window.open(imageUrl);
  }

 
  let columns;
  const [currentRow, setCurrentRow] = useState({})
  const [renderType, setRenderType] = useState("edit")
  const [iter, setIter] = useState(0)
  const [page, setPage] = useState(1)
  {
    serviceHistory.map((i, k) => {
      console.log(i, k);
      columns = [
        {
          name: "Service Date",
          selector: (i) => i?.serviceDate.split(" ")[0],
          ignoreRowClick: true,
        },

        {
          name: "Odometer",
          selector: (i) => i?.odometer,
          ignoreRowClick: true,
          
        },
        {
          name: "Duration(KM)",
          selector: (i) => i?.expectedDuration,
          ignoreRowClick: true,
          
        },
        {
          name: "Cost",
          selector: (i) => "₹ " + i?.price?.toLocaleString("en-IN"),
          ignoreRowClick: true,
          
        },
        {
          name: "Tag",
          selector: (i) => i?.tagId,
          ignoreRowClick: true,
          
        },
        {
          name: "Image",
          selector: (i) =>
            i?.imageUrl ? (
              <div style={{display: "flex",flexDirection:"row" }}>
              <button
                style={{
                  border: 0,
                  backgroundColor: "#fff",
                }}
                onClick={() => {
                  if( !imageUrl){
                    dispatch(
                      getSignedUrlApiAction(
                        { key: i?.imageUrl },
                        (res) => {
                          // setDownloadLoader2(false);
                          // setLoaderInvoiceId("");
                          if (res.status == 200) {
                            setImageUrl(res?.data?.data)
                            
                          }
                        }
                      )
                    );
                  }
                  toggleImageModal()
                }}
              >
                <SvgImage name="viewInvoicesBlue" />
              </button>
              <div style={{marginLeft: "20px"}} onClick={  printDocument(i?.imageUrl)}>
                <SvgImage name="downloadImg" width="24" height="24" />
              </div>
              </div>

            ) : (
              <SvgImage name="cancelOrder" height="21" width="21" />
            ),
          ignoreRowClick: true,

        },
        {
          name: "",
          cell: (i, int) => ( 
            <div onClick={()=>{ 
              console.log("currentRowcurrentRowcurrentRow111",int);
              if(currentRow == i) setCurrentRow(null)
              else {
                setCurrentRow(i)
                setRenderType("edit")
                setIter((page-1) * 10 + int)
              }

                }}>
              <SvgImage name="editLogo" width="25" height="25" /> 
            </div>
            
          ),
          width: "70px",
          button: true
        },
        {
          name: "",
          cell: (i, int) => (
            <div data-tag="allowRowEvents" onClick={() => {
              console.log("deleteClickeddeleteClickeddeleteClicked", i);
                dispatch(
                  deleteServiceHistory(
                    { VehicleProfileId: i?.VehicleProfileId },
                    (res) => {
                      if (res.status == 200) {
                        console.log("deleteClickeddeletckedSuccessSuccessSuccessSuccess");
                        dispatch(getServiceHistory({fleetId,expenseType}, (res)=> {
                          console.log("useEffectServiceHistory",res?.data?.data);
                        }))
                        if(int == 0){
                          dispatch(getVehicleProfileData({fleetId}, (res)=> {
                            console.log("useEffectServiceHistory",res?.data?.data);
                          }))
                        }
                      }
                    }
                  )
                );
            }}>
              <SvgImage name="deleteIcon2" />
            </div>
          ),
          width: "60px",
          button: true
        },
        {
          name: "Insert Below",
          cell: (i, int) => (
            <div onClick={()=>{ 
              console.log("currentRowcurrentRowcurrentRow222", int);
              if(currentRow == i) setCurrentRow(null)
              else {
                setCurrentRow(i)
                setRenderType("insert")
                setIter((page-1) * 10 + int)
              }
              }}
              style={{display: "flex", flexDirection: "row",justifyContent:"right"}}>
              <div> <SvgImage name="downArrow" width="24" height="24" /></div>
            </div>
          ),
          width: "130px",
          button: true
        },
        
      ];
    });
  }
  const fetchHistory = async (page) => {
    console.log("kljkkkk", page);
    setPage(page)
    setLoading(true);
    dispatch(
      getServiceHistory(
        {
          fleetId,
          expenseType,
          offset: (page-1) * 10,
          limit: 10,
        },
        () => {
          setLoading(false);
        }
      )
    );
    setLoading(false);
  };
  const handlePageChange = (page) => {
    fetchHistory(page);
  };
  const ExpandedComponent = (elem) => {
    console.log("ExpandedComponent", elem,"ajdhg ", renderType);
    return (<pre>
      <ProfileUpdateRender
        type={type}
        value={value}
        data={elem?.data}
        fleetId={fleetId}
        create={false}
        renderType={renderType}
        serviceHistory={serviceHistory}
        serviceHistoryCount={serviceHistoryCount}
        iter={iter}
        />
    </pre>)
  }
    return  (<div style={{padding:"10px"}}>
              {serviceHistoryCount == undefined ||
        (serviceHistoryCount > 0 && serviceHistory?.length == 0) ? (
          <div
            className="mt-2 boxContainer"
            style={{
              padding: 70,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BallTriangle
              height={70}
              width={70}
              radius={5}
              color="#2e7c7b"
              ariaLabel="ball-triangle-loading"
              wrapperClass={{}}
              wrapperStyle=""
              visible={true}
            />
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={serviceHistory}
            customStyles={{
              headRow: {
                style: {
                  backgroundColor: "#ededf1",
                  fontSize: "16px",
                  fontWeight: "bold",
                },
              },
              cells: {
                style: { fontSize: "14px", minHeight: "50px" },
              },
            }}
            fixedHeader
            // fixedHeaderScrollHeight='450px'
            highlightOnHover
            expandableRows={true}
            expandOnRowClicked={true}
            expandableRowsHideExpander={true}
            expandOnRowDoubleClicked={false}
            expandableRowsComponent={ExpandedComponent} 
            onRowClicked={(row) => {
            
            }}
            expandableRowExpanded={(row) => {
              console.log(
                "knnirii",serviceHistory.length,
                row?.VehicleProfileId,
                row == currentRow,
                currentRow?.VehicleProfileId
              );
              return row?.VehicleProfileId == currentRow?.VehicleProfileId;
            }}
            progressPending={loading}
            pagination={true}
            paginationComponentOptions={{noRowsPerPage:true}}
            paginationRowsPerPageOptions={[10]}
            paginationTotalRows={serviceHistoryCount}
            onChangePage={handlePageChange}
          />
        )}
              {imageModal ? <ImageModal
                toggle={toggleImageModal}
                imageModal={imageModal}
                setImageModal={setImageModal}
                image={imageUrl.split('?')[0]}
              />:<></>}
            </div> )
}
export default ServiceHistory;


